if (!customElements.get('featured-collection')) {
  customElements.define(
    'featured-collection',
    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.featured-collection__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.blockId = this.dataset.blockId;
        this.block = this.closest(`[data-id="${this.blockId}"`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);
        this.laptopItems = parseInt(this.dataset.laptopItems);
        this.paginationType = this.dataset.paginationType || 'bullets';

        this.sliderInstance = false;

        if (!this.enableSlider) return;

        // En celular el Swiper se destruye y el carrusel es scroll CSS; las
        // flechas se conectan aqui para desplazar una tarjeta por clic (como
        // la flecha de yarnspirations.com).
        this.setupMobileNav();

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
      }

      setupMobileNav() {
        if (this._mobileNavReady || !this.block) return;
        this._mobileNavReady = true;
        const next = this.block.querySelector(this.selectors.nextEl);
        const prev = this.block.querySelector(this.selectors.prevEl);
        const paso = (dir) => {
          if (typeof this.sliderInstance === 'object') return; // desktop: lo maneja Swiper
          const gap = parseFloat(getComputedStyle(this.sliderWrapper).columnGap) || 0;
          this.scrollBy({ left: dir * (this.clientWidth + gap), behavior: 'smooth' });
        };
        if (next) next.addEventListener('click', () => paso(1));
        if (prev) prev.addEventListener('click', () => paso(-1));

        // La flecha de regreso solo se ve de la segunda tarjeta en adelante:
        // cuando el scroll esta al inicio, la clase mobile-at-start (el CSS
        // la oculta) se pone en el bloque.
        const alPrincipio = () => {
          this.block.classList.toggle('mobile-at-start', this.scrollLeft < 40);
        };
        this.addEventListener('scroll', alPrincipio, { passive: true });
        alPrincipio();
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;
        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        // Columnas y avance calcados de yarnspirations.com:
        //   movil 1 | 768px: 2 | 1024px en adelante: 3 (arriba de 1024 ya no cambia).
        //   Su carrusel topa las tablets en 2 columnas, por eso el Math.min.
        //   slidesPerGroup = las que se ven, para que avance de pagina completa como ellos.
        const tabletItems = Math.min(this.tabletItems, 2);

        // SIN mousewheel: estaba activo (forceToAxis) y el arrastre lateral del
        // trackpad al hacer scroll por la pagina movia el carrusel "solo". El
        // dueno pidio que solo avance con las flechas (o arrastrando a proposito).
        this.sliderOptions = {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.block.querySelector(this.selectors.nextEl),
            prevEl: this.block.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.block.querySelector(this.selectors.pagination),
            type: this.paginationType,
          },
          breakpoints: {
            768: {
              slidesPerView: tabletItems,
              slidesPerGroup: tabletItems,
            },
            1024: {
              slidesPerView: this.laptopItems,
              slidesPerGroup: this.laptopItems,
            },
            1280: {
              slidesPerView: this.items,
              slidesPerGroup: this.items,
            },
          },
          loop: false,
          threshold: 2,
          watchSlidesProgress: true,
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
        this.sliderInstance.init();

        this.calcNavButtonsPosition();
        this.fixQuickviewDuplicate();
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }

      calcNavButtonsPosition() {
        if (this.dataset.navigationPosition !== 'center_image') return;

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        const controls = this.block.querySelector('.swiper-controls');
        if (controls && firstMedia && firstMedia.clientHeight > 0) {
          controls.style.setProperty('--swiper-navigation-top-offset', parseInt(firstMedia.clientHeight) / 2 + 'px');
        }
      }
    }
  );
}
